
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.53 1.22a.75.75 0 00-1.06 0L7.4 2.29a.75.75 0 00-.16.83l.5 1.16-2.2 1.6-1.4-.36a.75.75 0 00-.72.2l-.7.7a.75.75 0 000 1.06l2.3 2.3-2.9 2.9a.6.6 0 00.85.85l2.9-2.9 2.3 2.3a.75.75 0 001.06 0l.7-.7a.75.75 0 00.2-.72l-.36-1.4 1.6-2.2 1.16.5a.75.75 0 00.83-.16l1.07-1.07a.75.75 0 000-1.06l-4.9-4.9zM9 2.82L13.18 7l-.36.36-1.16-.5a.75.75 0 00-.9.24l-2.2 3.03a.75.75 0 00-.12.63l.36 1.4-.12.12-4.44-4.44.12-.12 1.4.36a.75.75 0 00.63-.12l3.03-2.2a.75.75 0 00.24-.9l-.5-1.16.36-.36z","fill-rule":"evenodd","fill":"currentColor"}})])
          )
        }
      }
    